// max message size - see
// https://bugs.chromium.org/p/webrtc/issues/detail?id=7774&desc=3
// https://developer.mozilla.org/en-US/docs/Web/API/WebRTC_API/Using_data_channels#Understanding_message_size_limits
export const MAX_DATA_SIZE_BYTES = 65536;

export function chunkDispatch(
  arrayBuffer,
  dispatchfn,
  maxsize = MAX_DATA_SIZE_BYTES
) {
  const bytes = arrayBuffer.byteLength;
  for (let i = 0; i < bytes; i += maxsize) {
    const slice = arrayBuffer.slice(i, i + maxsize);
    dispatchfn(slice);
  }
}

export function chunk(arrayBuffer, maxsize = MAX_DATA_SIZE_BYTES) {
  if (maxsize > MAX_DATA_SIZE_BYTES) {
    maxsize = MAX_DATA_SIZE_BYTES;
  }
  const bytes = arrayBuffer.byteLength;
  const out = [];
  for (let i = 0; i < bytes; i += maxsize) {
    const slice = arrayBuffer.slice(i, i + maxsize);
    out.push(slice);
  }
  return out;
}

export function unchunk(arrayofbuffers, sumbytes = null) {
  if (!arrayofbuffers || arrayofbuffers.length === 0) {
    return null;
  }
  const totalBytes =
    sumbytes || arrayofbuffers.reduce((acc, n) => acc + n.byteLength, 0);

  const tmp = new Uint8Array(totalBytes);
  arrayofbuffers.reduce((acc, n) => {
    tmp.set(new Uint8Array(n), acc);
    return acc + n.byteLength;
  }, 0);
  return tmp;
}

/**
 * Merge two buffers into one.
 * @param {ArrayBuffer} buffer1
 * @param {ArrayBuffer} buffer2
 * @returns {Uint8Array}
 */
export function mergeBuffers(buffer1, buffer2) {
  if (!buffer1) {
    return buffer2;
  }
  if (!buffer2) {
    return buffer1;
  }
  const tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
  tmp.set(new Uint8Array(buffer1), 0);
  tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
  return tmp;
}
